<div class="input">
    <input-field #descriptionField class="description-input" [value]="description" (valueChange)="_onDescriptionChange($event)" title="Naam"></input-field>
</div>
<div class="category-box-container">
    <div class="gradient-border">
        <div class="box">
            <div class="category-container" *ngFor="let cat of filteredItems">
                <div class="category">
                    <input type="checkbox" (change)="_onCategorySelect(cat)" [checked]="cat.selected" class="regular-checkbox" />
                    <!-- <div class="category" (click)="onClickCategory(cat)" > -->
                    <div class="opener" (click)="_onClickOpenCategory(cat, $event)">
                        <i class="fas" [class.fa-caret-right]="cat.open | not" [class.fa-caret-down]="cat.open"></i>
                    </div>
                    <div class="code" (click)="_onClickOpenCategory(cat, $event)">{{ cat.code }} </div>
                    <div class="description" (click)="_onClickOpenCategory(cat, $event)">{{ cat.name }}</div>
                </div>
                <ng-container *ngIf="cat.open">
                    <div class="library-item" (click)="_onLibraryItemSelect(cat, item)" *ngFor="let item of cat.items">
                        <input type="checkbox" [checked]="item.selected" class="regular-checkbox" />
                        <div class="description">{{ item.name }}</div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="footer">
    <div class="button-thin" [class.active]="canAdd" (click)="addItems()">Toevoegen</div>
</div>